import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store/store";
import { ExportHistoryRecord, PaymentSortBy, PaymentPagination } from "@/types/payment";

interface ExportHistoryState {
  sortBy: PaymentSortBy[];
  pagination: PaymentPagination;
  searchQuery: string;
  exportHistoryData: ExportHistoryRecord[] | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: ExportHistoryState = {
  sortBy: [],
  pagination: { 
    pageSize: 25, 
    pageNumber: 1, 
    page: 1, 
    per_page: 25, 
    total: 0, 
    total_pages: 0 
  },
  searchQuery: "",
  exportHistoryData: null,
  isLoading: false,
  error: null,
};

const ExportHistorySlice = createSlice({
  name: "exportHistory",
  initialState,
  reducers: {
    setExportHistoryData: (state, action: PayloadAction<ExportHistoryRecord[] | null>) => {
      state.exportHistoryData = action.payload;
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    setSortBy: (state, action: PayloadAction<PaymentSortBy[]>) => {
      state.sortBy = action.payload;
    },
    setPagination: (state, action: PayloadAction<PaymentPagination>) => {
      state.pagination = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setExportHistoryData,
  setSearchQuery,
  setSortBy,
  setPagination,
  setLoading,
  setError,
} = ExportHistorySlice.actions;

export const exportHistorySelector = (state: RootState) => state.exportHistory;

export default ExportHistorySlice.reducer;
